import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  ElementRef,
} from '@angular/core';
import { PopUpService } from 'src/app/popupservice.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { User } from 'src/app/shareModule/models/user.model';
import { select } from '@ngrx/store';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { loadDiscount } from 'src/app/shareModule/states/nearby';
import { selectDiscountData, selectDiscountLoading, selectDiscountError } from 'src/app/shareModule/states/nearby';
import { DiscountData } from 'src/app/shareModule/states/nearby/nearby.state';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss'],
})
export class DiscountComponent implements OnInit, OnChanges {
  @ViewChild('editModalTemplate', { static: true })
  editModalTemplate!: TemplateRef<any>;
  @ViewChild('uploadModalTemplate', { static: true })
  uploadModalTemplate!: TemplateRef<any>;
  seeMore: boolean = true;
  isLongText = false;
  @ViewChild('textElement') textElement!: ElementRef;

  constructor(
    private popupService: PopUpService,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    public commonService: CommonService,
    private local: LocalServiceService,
    private store: Store<AppState>,
    private roleService: RoleService,
    private seo: SeoService,
    public sharedService: SharedService
  ) { }

  @Input() filter: string = 'homepage';
  @Output() openBookModal = new EventEmitter<any>();
  isOpen = false;
  isLoading = false;
  imageUrl: string = environment.ImageUrl;

  discountData: DiscountData = {
    id: null,
    title: '',
    description: '',
    banner_image: '',
    filter: this.filter,
    DiscountLists: [],
    showBiggerBanner: false,
    showBanner: true,
  };

  uploadData = {
    amount: null,
    discountType: 'percentage',
    discountText: '',
    image: null,
    filter: this.filter,
  };

  imagePreview: string | null = null;
  selectedFile: File | null = null;
  bannerImagePreviews: Array<{ url: string; file: File }> = [];
  selectedBannerFiles: File[] = [];
  existingBannerImages: Array<{ url: string; index: number; isDeleted: boolean; replacementFile?: File; isReplaced?: boolean }> = [];
  iconItems: Array<{ icon: string; text: string; iconFile?: File; iconPreview?: string; isDeleted?: boolean; isReplaced?: boolean }> = [];
  iconItemFiles: Map<number, File> = new Map();
  user: User;
  isAdmin: boolean = false;

  carouselOptions: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      clickable: true,
    },
    loop: true,
    autoplay: {
      delay: 3000,
    },
  };

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((user: User) => {
      this.user = user;
      this.roleService.rolesSubject.subscribe((response) => {
        this.isAdmin = response?.userType?.includes('ADMIN');
        this.cdr.detectChanges();
      });
      this.cdr.detectChanges();
    });

    // Subscribe to discount data from store
    this.store.pipe(select(selectDiscountData)).subscribe((discountData) => {
      if (discountData) {
        if (discountData.id != null) {
          this.discountData = {
            ...discountData,
            filter: discountData.filter || this.filter,
            showBiggerBanner: discountData.showBiggerBanner !== undefined ? discountData.showBiggerBanner : false,
            showBanner: discountData.showBanner !== undefined ? discountData.showBanner : true,
          };
          // Parse icons if they exist
          if (discountData.icons) {
            try {
              const parsedIcons = typeof discountData.icons === 'string' ? JSON.parse(discountData.icons) : discountData.icons;
              this.iconItems = Array.isArray(parsedIcons) ? parsedIcons.map((item: any) => ({
                icon: item.icon || '',
                text: item.text || '',
                iconPreview: item.icon ? this.imageUrl + item.icon : undefined
              })) : [];
            } catch (e) {
              console.error('Error parsing icons:', e);
              this.iconItems = [];
            }
          } else {
            this.iconItems = [];
          }
          setTimeout(() => {
            this.calculateLines();
          }, 100);
        } else {
          this.discountData = {
            id: null,
            title: '',
            description: '',
            banner_image: '',
            filter: this.filter,
            DiscountLists: [],
            showBiggerBanner: false,
            showBanner: true,
          };
        }
        this.initSeo({
          title: this.discountData?.title || '',
          description: this.discountData?.description || '',
        });
        this.cdr.detectChanges();
      }
    });

    // Load discount data
    this.getDiscount();
  }

  private calculateLines() {
    const el = this.textElement?.nativeElement;
    if (this.sharedService.isBrowser()) {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const lines = Math.floor(el.scrollHeight / lineHeight);
      this.isLongText = lines > 2;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.filter = changes['filter'].currentValue;
      this.getDiscount();
      this.cdr.detectChanges();
    }
  }

  initSeo({ title, description }): void {
    if (this.sharedService.isBrowser()) {
      this.seo.updateTag({ name: 'description', content: description });
    }
  }

  getDiscount(): void {
    // Dispatch action to load discount
    this.store.dispatch(loadDiscount({ filter: this.filter }));
  }

  public modelRef: any = null;

  openEditModal(): void {
    this.discountData.filter = this.filter;
    // Reset banner image preview when opening edit modal
    this.bannerImagePreviews = [];
    this.selectedBannerFiles = [];

    // Initialize existing banner images for editing
    this.existingBannerImages = [];
    if (this.discountData.bannerImages && this.discountData.bannerImages.length > 0) {
      this.discountData.bannerImages.forEach((image, index) => {
        this.existingBannerImages.push({
          url: this.imageUrl + image,
          index: index,
          isDeleted: false
        });
      });
    } else if (this.discountData.banner_image) {
      // Handle legacy single banner_image
      this.existingBannerImages.push({
        url: this.imageUrl + this.discountData.banner_image,
        index: -1, // -1 indicates legacy banner_image
        isDeleted: false
      });
    }

    // Initialize icon items if they exist
    if (this.discountData.icons) {
      try {
        const parsedIcons = typeof this.discountData.icons === 'string' ? JSON.parse(this.discountData.icons) : this.discountData.icons;
        this.iconItems = Array.isArray(parsedIcons) ? parsedIcons.map((item: any) => ({
          icon: item.icon || '',
          text: item.text || '',
          iconPreview: item.icon ? this.imageUrl + item.icon : undefined,
          isDeleted: false,
          isReplaced: false
        })) : [];
      } catch (e) {
        console.error('Error parsing icons:', e);
        this.iconItems = [];
      }
    } else {
      this.iconItems = [];
    }
    this.iconItemFiles.clear();

    this.modelRef = this.popupService.openPopup(this.editModalTemplate, {
      modalSize: 'md',
      modalWindowClass: 'discount-edit-modal',
      modalArialLabelBy: 'modal-basic-title',
      data: this.discountData,
    });
  }

  openAddModal(): void {
    // Reset upload form
    this.uploadData = {
      amount: null,
      discountType: 'percentage',
      discountText: '',
      image: null,
      filter: this.filter,
    };
    this.imagePreview = null;
    this.selectedFile = null;

    this.modelRef = this.popupService.openPopup(this.uploadModalTemplate, {
      modalSize: 'md',
      modalWindowClass: 'discount-upload-modal',
      modalArialLabelBy: 'modal-basic-title',
    });
  }
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767;
  }
  closeModal() {
    if (this.modelRef) {
      if (this.isMobile) {
        this.modelRef.dismiss();
      } else {
        this.modelRef.close();
      }
    }
  }
  onImageSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onBannerImageSelected(event: any): void {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      // Process all selected files
      Array.from(files).forEach((file: File) => {
        // Check if file is already selected (avoid duplicates)
        const isDuplicate = this.selectedBannerFiles.some(
          (existingFile) => existingFile.name === file.name && existingFile.size === file.size
        );

        if (!isDuplicate) {
          this.selectedBannerFiles.push(file);

          // Create preview for each file
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.bannerImagePreviews.push({
              url: e.target.result,
              file: file
            });
            this.cdr.detectChanges();
          };
          reader.readAsDataURL(file);
        }
      });
    }
  }

  removeBannerImage(index: number): void {
    if (index >= 0 && index < this.bannerImagePreviews.length) {
      // Remove from both arrays
      const removedFile = this.bannerImagePreviews[index].file;
      this.bannerImagePreviews.splice(index, 1);

      // Find and remove from selectedBannerFiles
      const fileIndex = this.selectedBannerFiles.findIndex(
        (file) => file.name === removedFile.name && file.size === removedFile.size
      );
      if (fileIndex >= 0) {
        this.selectedBannerFiles.splice(fileIndex, 1);
      }
    }
  }

  deleteExistingBannerImage(index: number): void {
    if (index >= 0 && index < this.existingBannerImages.length) {
      // Mark as deleted instead of removing immediately
      this.existingBannerImages[index].isDeleted = true;
      this.cdr.detectChanges();
    }
  }

  waitForStoreUpdateAndRefresh(): void {
    // The store subscription in ngOnInit will automatically update discountData
    // We just need to wait a bit for the store to process the update, then refresh the form
    // Using a reasonable timeout since the existing subscription handles the update
    setTimeout(() => {
      this.refreshFormAfterSave();
    }, 800);
  }

  refreshFormAfterSave(): void {
    // Clear all previews and selected files
    this.bannerImagePreviews = [];
    this.selectedBannerFiles = [];

    // Reinitialize existing banner images with updated data
    this.existingBannerImages = [];
    if (this.discountData.bannerImages && this.discountData.bannerImages.length > 0) {
      this.discountData.bannerImages.forEach((image, index) => {
        this.existingBannerImages.push({
          url: this.imageUrl + image,
          index: index,
          isDeleted: false
        });
      });
    } else if (this.discountData.banner_image) {
      // Handle legacy single banner_image
      this.existingBannerImages.push({
        url: this.imageUrl + this.discountData.banner_image,
        index: -1, // -1 indicates legacy banner_image
        isDeleted: false
      });
    }

    this.toastr.success('Discount updated successfully');
    this.cdr.detectChanges();
  }

  restoreExistingBannerImage(index: number): void {
    if (index >= 0 && index < this.existingBannerImages.length) {
      const existingImage = this.existingBannerImages[index];

      // If there was a replacement file, restore original URL
      if (existingImage.replacementFile) {
        // Restore original URL from discountData
        if (this.discountData.bannerImages && existingImage.index >= 0 && existingImage.index < this.discountData.bannerImages.length) {
          existingImage.url = this.imageUrl + this.discountData.bannerImages[existingImage.index];
        } else if (this.discountData.banner_image && existingImage.index === -1) {
          existingImage.url = this.imageUrl + this.discountData.banner_image;
        }
        existingImage.replacementFile = undefined;
        existingImage.isReplaced = false;
      }

      // Restore if user changes mind (for deleted images)
      existingImage.isDeleted = false;
      this.cdr.detectChanges();
    }
  }

  replaceExistingBannerImage(index: number, event: any): void {
    const file = event.target.files[0];
    if (file && index >= 0 && index < this.existingBannerImages.length) {
      // Store the replacement file with the existing image
      const existingImage = this.existingBannerImages[index];

      // If there was already a replacement file, remove it from previews
      if (existingImage.replacementFile) {
        const oldPreviewIndex = this.bannerImagePreviews.findIndex(
          preview => preview.file === existingImage.replacementFile
        );
        if (oldPreviewIndex >= 0) {
          this.bannerImagePreviews.splice(oldPreviewIndex, 1);
        }
        const oldFileIndex = this.selectedBannerFiles.findIndex(
          f => f === existingImage.replacementFile
        );
        if (oldFileIndex >= 0) {
          this.selectedBannerFiles.splice(oldFileIndex, 1);
        }
      }

      // Mark as replaced (not deleted) and store replacement file
      existingImage.isReplaced = true;
      existingImage.replacementFile = file;

      // Update the preview URL to show the new image
      const reader = new FileReader();
      reader.onload = (e: any) => {
        // Update the existing image preview URL
        existingImage.url = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);

      // Reset input
      event.target.value = '';
    }
  }

  addIconItem(): void {
    this.iconItems.push({
      icon: '',
      text: '',
      isDeleted: false,
      isReplaced: false
    });
    this.cdr.detectChanges();
  }

  removeIconItem(index: number): void {
    if (index >= 0 && index < this.iconItems.length) {
      this.iconItems[index].isDeleted = true;
      this.iconItemFiles.delete(index);
      this.cdr.detectChanges();
    }
  }

  restoreIconItem(index: number): void {
    if (index >= 0 && index < this.iconItems.length) {
      this.iconItems[index].isDeleted = false;
      this.cdr.detectChanges();
    }
  }

  onIconFileSelected(index: number, event: any): void {
    const file = event.target.files[0];
    if (file && index >= 0 && index < this.iconItems.length) {
      this.iconItemFiles.set(index, file);
      this.iconItems[index].isReplaced = true;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.iconItems[index].iconPreview = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);

      // Reset input
      event.target.value = '';
    }
  }

  saveChanges(): void {
    this.isLoading = true;

    // Delete existing images that are marked for deletion
    const imagesToDelete = this.existingBannerImages
      .filter(img => img.isDeleted)
      .map(img => img.index);

    // Delete images one by one
    if (imagesToDelete.length > 0) {
      let deletePromises = imagesToDelete.map(index => {
        return new Promise<void>((resolve, reject) => {
          this.customerService.deleteUploadedImage(this.discountData.id, index >= 0 ? index : undefined)
            .subscribe(
              (res) => resolve(),
              (err) => reject(err)
            );
        });
      });

      Promise.all(deletePromises).then(() => {
        // After deletions, upload new images if any
        this.uploadNewBannerImages();
      }).catch((err) => {
        this.isLoading = false;
        this.toastr.error('Failed to delete some banner images');
        // Still try to upload new images
        this.uploadNewBannerImages();
      });
    } else {
      // No deletions, just upload new images
      this.uploadNewBannerImages();
    }
  }

  private uploadNewBannerImages(): void {
    // Collect replacement files and their indices
    const replacementFiles: Array<{ file: File; index: number }> = [];

    // Get replacement files from existing images
    this.existingBannerImages.forEach((existingImage) => {
      if (existingImage.replacementFile && existingImage.isReplaced) {
        replacementFiles.push({
          file: existingImage.replacementFile,
          index: existingImage.index
        });
      }
    });

    // New files are those in selectedBannerFiles (these are from the "Choose Images" button)
    const newFiles: File[] = [...this.selectedBannerFiles];

    // If there are any files to upload (replacements or new)
    if (replacementFiles.length > 0 || newFiles.length > 0) {
      const formData = new FormData();
      formData.append('title', this.discountData.title);
      formData.append('description', this.discountData.description);
      formData.append('filter', this.discountData.filter);
      if (this.discountData.shareWithOtherTitle !== undefined) {
        formData.append('shareWithOtherTitle', this.discountData.shareWithOtherTitle || '');
      }
      if (this.discountData.showBiggerBanner !== undefined) {
        formData.append('showBiggerBanner', this.discountData.showBiggerBanner ? 'true' : 'false');
      }
      if (this.discountData.showBanner !== undefined) {
        formData.append('showBanner', this.discountData.showBanner ? 'true' : 'false');
      }

      // Handle icon items if showBanner is false
      if (!this.discountData.showBanner) {
        const activeIconItems = this.iconItems.filter(item => !item.isDeleted);
        const iconsData: Array<{ icon: string; text: string }> = [];
        
        activeIconItems.forEach((item, idx) => {
          const originalIndex = this.iconItems.indexOf(item);
          const iconData: { icon: string; text: string } = {
            icon: item.icon || '',
            text: item.text || ''
          };
          iconsData.push(iconData);
          
          // Append icon file if it exists
          if (this.iconItemFiles.has(originalIndex)) {
            const file = this.iconItemFiles.get(originalIndex);
            if (file) {
              formData.append(`iconFile_${idx}`, file);
            }
          }
        });
        
        formData.append('icons', JSON.stringify(iconsData));
      }

      // Build replace indices array: index for replacements, empty string for new files
      const replaceIndices: string[] = [];

      // Add replacement files first with their indices
      replacementFiles.forEach((rf) => {
        formData.append('bannerImage', rf.file);
        replaceIndices.push(rf.index.toString());
      });

      // Add new files (no index, so empty string)
      newFiles.forEach(() => {
        // Files will be added below, just track the index position
        replaceIndices.push('');
      });

      // Actually append new files to formData
      newFiles.forEach((file) => {
        formData.append('bannerImage', file);
      });

      // Send replacement indices as comma-separated string (only if there are replacements)
      if (replacementFiles.length > 0) {
        formData.append('replaceImageIndices', replaceIndices.join(','));
      }

      if (this.discountData.id) {
        formData.append('id', this.discountData.id.toString());
      }

      this.customerService.createDiscount(formData).subscribe(
        (res) => {
          this.isLoading = false;
          this.getDiscount();
          // Wait for store to update, then refresh the form
          this.waitForStoreUpdateAndRefresh();
        },
        (err) => {
          this.isLoading = false;
          this.toastr.error('Failed to update discount');
        }
      );
    } else {
      // No new banner images, just update title/description and icons
      const formData = new FormData();
      formData.append('title', this.discountData.title || '');
      formData.append('description', this.discountData.description || '');
      formData.append('filter', this.discountData.filter);
      if (this.discountData.shareWithOtherTitle !== undefined) {
        formData.append('shareWithOtherTitle', this.discountData.shareWithOtherTitle || '');
      }
      if (this.discountData.showBiggerBanner !== undefined) {
        formData.append('showBiggerBanner', this.discountData.showBiggerBanner ? 'true' : 'false');
      }
      if (this.discountData.showBanner !== undefined) {
        formData.append('showBanner', this.discountData.showBanner ? 'true' : 'false');
      }

      // Handle icon items if showBanner is false
      if (!this.discountData.showBanner) {
        const activeIconItems = this.iconItems.filter(item => !item.isDeleted);
        const iconsData: Array<{ icon: string; text: string }> = [];
        
        activeIconItems.forEach((item, idx) => {
          const originalIndex = this.iconItems.indexOf(item);
          const iconData: { icon: string; text: string } = {
            icon: item.icon || '',
            text: item.text || ''
          };
          iconsData.push(iconData);
          
          // Append icon file if it exists
          if (this.iconItemFiles.has(originalIndex)) {
            const file = this.iconItemFiles.get(originalIndex);
            if (file) {
              formData.append(`iconFile_${idx}`, file);
            }
          }
        });
        
        formData.append('icons', JSON.stringify(iconsData));
      }

      if (this.discountData.id) {
        formData.append('id', this.discountData.id.toString());
      }

      this.customerService.createDiscount(formData).subscribe(
        (res) => {
          this.isLoading = false;
          this.getDiscount();
          // Wait for store to update, then refresh the form
          this.waitForStoreUpdateAndRefresh();
        },
        (err) => {
          this.isLoading = false;
          this.toastr.error('Failed to update discount');
        }
      );
    }
  }

  saveUpload(): void {
    if (!this.uploadData.amount) {
      this.toastr.error('Please enter discount amount');
      return;
    }

    this.isLoading = true;

    const formData = new FormData();
    formData.append('discountId', this.discountData.id.toString());
    formData.append('amount', this.uploadData.amount.toString());
    formData.append('discountType', this.uploadData.discountType);
    formData.append('discountText', this.uploadData.discountText);

    if (this.selectedFile) {
      formData.append('image', this.selectedFile);
    }

    this.customerService.uploadDiscount(formData).subscribe(
      (res) => {
        this.isLoading = false;
        this.getDiscount();
        this.popupService.clearHistory();
        this.toastr.success('Discount item created successfully');
      },
      (err) => {
        this.isLoading = false;
        this.toastr.error('Failed to create discount item');
      }
    );
  }

  deleteDiscountItem(itemId: number): void {
    this.local.alertConfirm({}).then((res) => {
      if (res.isConfirmed) {
        this.isLoading = true;

        this.customerService
          .deleteDiscount({
            id: itemId,
          })
          .subscribe(
            (res) => {
              this.isLoading = false;
              this.getDiscount();
              this.toastr.success('Discount item deleted successfully');
            },
            (err) => {
              this.isLoading = false;
              this.toastr.error('Failed to delete discount item');
            }
          );
      }
    });
  }

  deleteBannerImage(imageIndex?: number): void {
    this.local.alertConfirm({}).then((res) => {
      if (res.isConfirmed) {
        this.customerService
          .deleteUploadedImage(this.discountData.id, imageIndex)
          .subscribe(
            (res) => {
              this.getDiscount();
              this.toastr.success('Banner image deleted successfully');
            },
            (err) => {
              this.toastr.error('Failed to delete banner image');
            }
          );
      }
    });
  }
}
